<div class="user-card">
  <div class="widget">

      <div 
      fxLayout="row" 
      fxLayoutAlign="space-between" 
      class="widget-header"
      matTooltip="{{assignment.LessonName}}" 
      [ngStyle]="{'background-color': colorCode}"
      (click)="onAssignmentClick()">

          <span fxFlex="85">
              {{ assignment.LessonName }}
          </span>
          <span>
              <a class="icon-wrapper"
                  target="_blank"
                  [routerLink]="['/LearningContent/LessonEdit.aspx']"
                  [queryParams]="{LessonID: assignment.LessonID, AssignmentID: assignment.AssignmentID}">
              <mat-icon class="material-icons-outlined icon a-icon">language</mat-icon>
          </a>
          </span>
      </div>
      <div class="widget-body text-center">
          <div class="text-box btm-border">
              <div class="text-muted left">
                  Status: &nbsp;
              </div>
              <div class="text-muted right">
                <span class="text">{{ assignment.Status || '-'}}</span>
              </div>
          </div>

          <div fxLayout="row" class="text-box btm-border">
              <div class="text-muted left">
                  Locked
                  <div>
                      <mat-slide-toggle   [checked]="assignment.SubmittedAsComplete"
                                          (change)="lockAssignmentChanged(toggleLock)"
                                          [disabled]="assignment.CompleteDate"
                                          #toggleLock>
                      </mat-slide-toggle>
                  </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between" class="text-muted right">
                  <div fxLayout="column" fxLayoutAlign="space-between">
                      Submitted
                      <div class="text pt-1"
                          [ngClass]="{'success': completionStatus === 'onTime',
                                      'failure': completionStatus === 'delay'}">
                          {{ assignment.CompleteDate || '-'}}
                      </div>
                  </div>

                  <div fxLayout="column" fxLayoutAlign="center" class="icon-wrapper">
                      <a (click)="onViewWork()">
                          <mat-icon class="material-icons-outlined icon">description</mat-icon>
                      </a>
                  </div>
              </div>
          </div>

          <div class="controls-wrapper">
              <div *ngIf="assignment.SubmittedAsComplete" fxLayout="row" class="text-box btm-border">
                  <div fxLayout="column" fxLayoutAlign="space-between" class="text-muted left">
                      <div>
                          Grade: &nbsp;
                          <span class="text">{{ assignment.Grade || '-'}}</span>
                      </div>
                      <div class="grade-button-wrapper">
                          <button
                                  class="grade-button gradient-border"
                                  mat-button
                                  type="button"
                                  (click)="onGradeClick()"
                          >
                              Grade
                          </button>
                      </div>
                      <div class="grade-button-wrapper mt-10">
                          <button
                                  class="grade-button gradient-border"
                                  mat-button
                                  type="button"
                                  (click)="onReassignClick()"
                          >
                              Reassign
                          </button>
                      </div>
                      
                  </div>

                  <div fxLayout="column" fxLayoutAlign="space-between" class="text-muted right">
                      <div fxLayoutAlign="center">
                          Release
                      </div>
                      <div fxLayoutAlign="space-between center">
                          Grade
                          <mat-slide-toggle   [checked]="assignment.GradeReleased"
                                              [disabled]="!canReleaseGrade"
                                              (change)="releaseGradeChanged(toggleGrade)"
                                              #toggleGrade>
                          </mat-slide-toggle>
                      </div>
                      <div fxLayoutAlign="space-between center">
                          Answer Key
                          <mat-slide-toggle   [checked]="assignment.AnswerKeyReleased"
                                              [disabled]="!canReleaseAnswerKey"
                                              (change)="releaseAnswerKeyChanged(toggleAnswerKey)"
                                              #toggleAnswerKey>
                          </mat-slide-toggle>
                      </div>
                  </div>
              </div>
              <div fxLayout="column" fxLayoutAlign="center" *ngIf="!assignment.SubmittedAsComplete" class="display-message btm-border">
                  To grade, or reassign, first Lock the assignment.
                  <div class="grade-button-wrapper mt-10 mb-10">
                    <button
                            [disabled]="assignment.SubmittedAsComplete"
                            class="grade-button gradient-border"
                            mat-button
                            type="button"
                            (click)="openUnassignDialog()"
                    >
                        Unassign
                    </button>
                </div>
              </div>
            <div>
          </div>

          <div class="see-more-container">
              <div class="see-more-wrapper">
                  <mat-expansion-panel>
                      <mat-expansion-panel-header>
                          <mat-panel-title class="see-more-title">
                              See More
                          </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div fxLayout="column" class="see-more-content">
                          <div fxLayout="row" class=" see-more-item btm-border">
                              <div fxFlex="55" class="text-muted left">
                                  Attempt Count
                              </div>
                              <div class="text-muted left">
                                  {{ assignment.AttemptCount }}
                              </div>
                          </div>
                          <div class="see-more-item">
                              <div class="text-muted left">
                                  Start Date
                                  <div class="text pt-1">
                                      {{ assignment.StartDate }}
                                  </div>
                              </div>
                              <div class="text-muted right">
                                  Due Date
                                  <div class="text pt-1">
                                      {{ assignment.DueDate }}
                                  </div>
                              </div>
                          </div>
                      </div>
                  </mat-expansion-panel>
              </div>
          </div>

      </div>
  </div>
</div>
